module.exports = __webpack_public_path__ + "img/menu01.59f903cc.jpg";